<router-outlet *ngIf="portfolio && portfolio.id"></router-outlet>
